export type TProjectName = string;

export type TProjectDescription = string;

export type TProjectMotivation = "Idea" | "Technology" | "Inspiration";

export interface IProjectDetailsData {
  projectName: TProjectName;
  projectDescription: TProjectDescription;
  projectMotivation: TProjectMotivation;
}

export const defaultProjectDetailsData: IProjectDetailsData = {
  projectName: "",
  projectDescription: "",
  projectMotivation: "Idea",
};
